/** @format */

export const StarSmall = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_64_104)">
                <path
                    d="M8.00033 12.4541L12.5323 15.3334L11.3297 9.90669L15.3337 6.25546L10.061 5.78458L8.00033 0.666687L5.93966 5.78458L0.666992 6.25546L4.67099 9.90669L3.46833 15.3334L8.00033 12.4541Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_64_104">
                    <rect width="16" height="16" fill={color} />
                </clipPath>
            </defs>
        </svg>
    );
};
